import styles from "./Profile.module.css";
import Link from "next/link";

interface ProfileProps {
  href: string;
  children: React.ReactNode;
}

const Profile = ({ href, children }: ProfileProps) => {
  return (
    <Link href={href} className={styles.Profile}>
      {children}
    </Link>
  );
};

export default Profile;
